if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        //Scroll to top when sticky add to cart button configured to sroll
        var stickyButtonSelector = document.querySelector('.sticky-add-to-cart-button-init.sticky-add-to-cart-button.sticky-button-scroll-top');
        if(stickyButtonSelector != null)
        {
            stickyButtonSelector.textContent = window.variantStrings.addToCart;
             $('html, body').stop().animate({
                    'scrollTop': $(window).width() > 768 ? $("body").offset().top : $(".product__info-wrapper").offset().top - 60
              }, 1500, 'swing');
              return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const variantOptionChecked = document.querySelector(".variant-bundle-options .variant-bundle-option:has(.variant-bundle-option-radio:checked)");
        if(variantOptionChecked != null) {
          const freeProductIdEle = variantOptionChecked.querySelector("input[name='free-product-id']");
          const freeProductQtyEle = variantOptionChecked.querySelector("input[name='free-product-qty']");
          if(freeProductIdEle != null && freeProductIdEle.value != "" && freeProductQtyEle != null) {
              let freeProductData = {
                  'id': freeProductIdEle.value,
                  'quantity': freeProductQtyEle.value
              };
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(freeProductData)
              })
              .then((response) => response.json())
              .then((response) => {
                  this.addItemToCartMain();
              })
              .catch((error) => {
                 console.error('Error:', error);
              });
          }
          else {
            this.addItemToCartMain();
          }
        }
        else {
          this.addItemToCartMain();
        }
      }

      addItemToCartMain() {
        const variantBundleInnerVariantContainer = document.querySelector(".variant-bundle-inner-variant-container");
        if(variantBundleInnerVariantContainer != null) {
          const innerVariantSelectItems = variantBundleInnerVariantContainer.querySelectorAll(".variant-bundle-options .variant-bundle-option:has(.variant-bundle-option-radio:checked) .product-form__input-inner");
          if(innerVariantSelectItems != null && innerVariantSelectItems.length > 0) {
            const comboProductVariantSelectItems = variantBundleInnerVariantContainer.querySelectorAll(".variant-bundle-options .variant-bundle-option:has(.variant-bundle-option-radio:checked) .product-form__input-combo");
            this.addToCartBundleInnerVariant(innerVariantSelectItems, comboProductVariantSelectItems);
          }
          else {
            this.addItemToCartCommon();
          }
        }
        else {
          this.addItemToCartCommon();
        }
      }

      addItemToCartCommon() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
          
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            //Initialize Cart Countdown Timer
            InitCartCountdown();
            //Initialize Cart Free Shipping Bar
            InitCartFreeShippingBar();
          });
      }

       addToCartBundleInnerVariant(innerVariantSelectItems, comboProductVariantSelectItems) {              
            let innerItems = [];
            
            innerVariantSelectItems.forEach((innerVariantSelectItem) => {
               const checkedInnerVariantSelectItem = innerVariantSelectItem.querySelector("input[type=radio]:checked");
               innerItems.push({
                'id': checkedInnerVariantSelectItem.getAttribute("data-variant-id"),
                'quantity': 1
                });
            });
            if(comboProductVariantSelectItems != null && comboProductVariantSelectItems.length > 0) {
              comboProductVariantSelectItems.forEach((comboProductVariantSelectItem) => {
                 const checkedcomboProductVariantSelectItem = comboProductVariantSelectItem.querySelector("input[type=radio]:checked");
                 innerItems.push({
                  'id': checkedcomboProductVariantSelectItem.getAttribute("data-variant-id"),
                  'quantity': 1
                  });
              });
            }
         
            if(innerItems.length == 0) {
              return;
            }
            let formData = { 'items': innerItems.reverse() };
  
            if (this.cart) {
              formData.sections = this.cart.getSectionsToRender().map((section) => section.id)
              formData.sections_url = window.location.pathname;
              this.cart.setActiveElement(document.activeElement);
            }
            
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
              })
              .then((response) => response.json())
              .then((response) => {
                  if (response.status) {
                    //publish(PUB_SUB_EVENTS.cartError, {
                    //    source: 'product-form',
                    //    productVariantId: formData.get('id'),
                    //    errors: response.errors || response.description,
                    //    message: response.message,
                    //  });
                    this.handleErrorMessage(response.description);
        
                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                      window.location = window.routes.cart_url;
                      return;
                    }
        
                  //if (!this.error)
                  //    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
                  this.error = false;
                 
                  //this.cartNotification.renderContents(response);
                  // window.location = window.routes.cart_url;
                  if(response.items.length > 0) {
                    response.items.forEach((responseItem) => {
                      responseItem.sections = response.sections;
                      this.cart.renderContents(responseItem);
                    });
                  }
                  
                  //Klaviyo Tracking Snippet
                  //var _learnq = _learnq || [];
                  //_learnq.push(['track', 'Added to Cart', item]);
              })
              .catch((e) => {
                  console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');    
      
                //Initialize Cart Countdown Timer
                InitCartCountdown();
                //Initialize Cart Free Shipping Bar
                InitCartFreeShippingBar();
              });                           
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
